module.exports = __webpack_public_path__ + "img/mgh-kanazawa-sp.457d2515.jpg";